import api from 'modules/common/utils/api'
import queryString from 'query-string'
import Response from './Response'

export default class Endpoint<RequestT, DataT, MetaT = {}> {
  method: string = 'get'

  apiUrl: string = process.env.REACT_APP_REPORTS_API_URL || ''
  alternativeApiUrl: string | undefined

  urlParams: string[] = []

  get baseURL() {
    return this.alternativeApiUrl || this.apiUrl
  }

  buildPath(data: RequestT) {
    return 'path-not-defined'
  }

  private removeUrlParams(allData: RequestT) {
    const data = {...allData}

    this.urlParams.forEach(param => {
      delete data[param]
    })

    return data
  }

  protected cleanupRequestData(data: RequestT) {
    return data
  }

  fetch = async (requestData: RequestT): Promise<Response<DataT, MetaT>> => {
    const data = this.cleanupRequestData(this.removeUrlParams(requestData))
    const path = this.buildPath(requestData)

    const request = ['get', 'delete'].includes(this.method)
      ? this.fetchWithoUrlData(path, data)
      : this.fetchWithBodyData(path, data)

    const rawResponse = await request

    const response: Response<DataT, MetaT> = new Response(rawResponse)
    const processedData = this.process(response)
    if (processedData) response.data = processedData

    return response
  }

  process(_response: Response<DataT, MetaT>): DataT | void {}

  private fetchWithoUrlData(path: string, data: any) {
    const method = api[this.method] as Function
    const query = queryString.stringify(data || {})
    return method(`${path}?${query}`, {baseURL: this.baseURL})
  }

  private fetchWithBodyData(path: string, data: RequestT) {
    const method = api[this.method] as Function
    return method(path, data, {baseURL: this.baseURL})
  }
}
